import { Component, Input, OnInit, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ColorFromId, GeneralHelper, RestService } from "@stdoutsrl/design-kit"
import { api, environment } from "../../environments/environment";
import {  Message } from "@stdoutsrl/design-kit";
import { io, Socket } from 'socket.io-client';
import { TranslocoService } from "@jsverse/transloco";
import { LoaderService } from "../service/loader.service";
import { mapOptions } from "../models/map-options";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-live",
  templateUrl: "./live.component.html",
  styleUrl: './live.component.scss',
  standalone: false,
})
export class LiveComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
    private transloco: TranslocoService,
    private helper : GeneralHelper,
    private colorById:ColorFromId,
    private http:HttpClient
  ) { }

  emojiList: string[] = ["😀", "🥳", "😇", "🤠", "🤑", "🤓", "🤡", "😈", "👻", "💀", "🤖", "👹", "⛄", "👽", "🌞", "😺", "🙉", "⭐", "❤️", "💜", "🖤", "🦴", "🦷", "🌹", "🍀", "🍄", "🦁", "🐶", "🐺", "🐻", "🐻‍❄️", "🐨", "🐼", "🐹", "🐭", "🐰", "🦊", "🐮", "🐷", "🦄", "🐴", "🐢", "🐸", "🦉", "🍎", "🍓", "🍊", "🥭", "🥦", "🌰", "🍔", "🦞", "🍙", "🍥", "🍿", "🧁", "🍩"]
  liveId = ''
  newliveId = ''
  animatedButton = ''
  socket!: Socket;
  urlSocket: string = api.socketUrl;
  currentType = 0
  currentQuestion: {
    type: number;
    options?: string[]

  } = {
      type: 0
    }
  points = 100
  isQuestionStopped = false
  testColorIndex = -1
  timeoutTestColor: any
  answers: any[] = []
  answerToQuestion = ''
  isEmojiOpen = false
  quizEnded = false
  mockIndexQuestion = -1
  setTimeoutBuzzer :any
  showAnswersBuzzer = false
  guessNumber = ''
  showModalExitLive = false
  isUserLogged = false
  showModalLogin = false
  showModalRegister = false
  isRegister = false
  email = ''
  password = ''
  showPassword = false
  isDisabledColor = false
  credentials: any = {};
  acceptPrivacy = false;
  acceptTerms = false;
  registerEmoji = ''
  messagePassword = ''
  user :any
  blockEmoji = false
  blockAnswers = false
  quizStatus = 1
  messageEmail = signal('')
  showRank = signal(false)
  buzzerTimeout = 5000
  timeBuzzer = 0
  showModalRecovery = false
  yourRank :{
    position:number;
    score:number
  }= {
    position:1,
    score:0
  }
    mapOptions :any= mapOptions
    timeoutNick :any
    timeoutEmail:any
    nickAlreadyUsed = false
    emailAlreadyUsed = false
    showTimer = false
    timerStart = 5
    showUserProfile = false
    window = window

  ngOnInit(): void {
    this.liveId = this.activatedRoute.snapshot.paramMap.get('id')!;
    if (localStorage.getItem('token')) {
      this.getMe()
    } else {
      this.showModalLogin = true
    }
  }  
  
  getHMap(){
    return window.innerHeight - 120
  }
  
  checkEmail(t: any) {
    let isMailValid = this.helper.isEmailValid(this.credentials.email)
    if (isMailValid) {
      this.messageEmail.set('theEmailIsValid')
      if (this.timeoutEmail) {
        clearTimeout(this.timeoutEmail)
      }
      this.timeoutEmail = setTimeout(() => {
        this.loader.on()
        this.rest.get(`/auth/check-duplicate-email?email=${this.credentials.email}`).subscribe({
          next: (value) => {
            this.emailAlreadyUsed = false
            this.loader.off()
          },
          error: (value) => {
            this.emailAlreadyUsed = true
            this.message.showMessage(t('alerts.' + value.error.message), 'error')
            this.loader.off()
          },
        })
      }, 500);
    } else {
      this.messageEmail.set('theEmailIsInvaild')
    }
  }

  exitQuiz() {
    if ((JSON.parse(localStorage.getItem('live') ?? '{}'))?.liveId) {
      this.rest.patch(`/quiz-participant/exitLive`, { session_id: (JSON.parse(localStorage.getItem('live') ?? '{}'))?.liveId }).subscribe({
        next: (value) => {
          localStorage.removeItem('live')
          window.location.replace('live')
        },
        error: (value) => {
          localStorage.removeItem('live')
          window.location.replace('live')
        },
      })
    } else {
      localStorage.removeItem('live')
      window.location.replace('live')
    }
  }

  afterAuth() {
    this.showModalLogin = false
    this.showModalRegister = false
    if (this.liveId) {
      
      this.joinSession()
    } else {
      // this.message.showMessage('Insert live id', 'error')
    }

  }

  showMessage(status: string, message: string) {
    this.message.showMessage(message, status);
  }

  showBirth(){
    let inputDate:any = document.getElementById('birth-date-registration')
    if(inputDate){
      setTimeout(() => {
      inputDate.showPicker()
      }, 0);
    }
  }

  checkNickname(t:any) {
    if (this.timeoutNick) {
      clearTimeout(this.timeoutNick)
    }
    this.timeoutNick = setTimeout(() => {
      this.loader.on()
      this.rest.get(`/auth/check-duplicate-nickname?nickname=${this.credentials.nickname}`).subscribe({
        next: (value) => {
          this.nickAlreadyUsed = false
          this.loader.off()
        },
        error: (value) => {
          this.nickAlreadyUsed = true
          this.message.showMessage(t('alerts.'+value.error.message),'error')
          this.loader.off()
        },
      })
    }, 500);

  }

  checkCredentials(t: any) {
    let errors = 0
    if (this.messageEmail() != 'theEmailIsValid') {
      errors++
      this.showMessage('error', t('theEmailIsInvaild'))
    }
    if (this.emailAlreadyUsed) {
      errors++
      this.showMessage('error', t('alerts.duplicateEmail'))
    }
    if (!this.credentials.nickname || this.nickAlreadyUsed) {
      errors++
      this.showMessage('error', t('needNickname'))
    }
    if (!this.credentials.birth_date) {
      errors++
      this.showMessage('error', t('needBirthDate'))
    }
    if (this.messagePassword != 'thePasswordIsSafe') {
      errors++
      this.showMessage('error', t('needPassword'))
    }
    if (this.credentials.password != this.credentials.confirmPassword) {
      errors++
      this.showMessage('error', t('needSamePassword'))
    }
    if (!this.registerEmoji) {
      errors++
      this.showMessage('error', t('needEmoji'))
    }
    if (!this.acceptTerms) {
      errors++
      this.showMessage('error', t('needTerms'))
    }
    if (errors == 0) {
      this.register(t)
    }
  }

  getMe() {
    this.http.get(api.baseUrl + '/user/me',{
      headers:{
        authorization:'Bearer ' + localStorage.getItem('token')
      }
    }).subscribe({
      next: (value:any) => {
        if(value.role == 4){
          this.transloco.selectTranslateObject("alerts").subscribe((alerts) => {
              this.message.showMessage(alerts.adminsNoLive,'error')
              this.router.navigate([''])
            })
          
        }
        this.user = value
        this.afterAuth()
      },
      error:(value) => {
        localStorage.clear()
        this.showModalLogin = true
      },
    })
  }

  updateEmoji(){
    this.loader.on()
    this.rest.patch(`/user/me`, {profile_icon:this.user.profile_icon}).subscribe({
      next: (value) => {
        this.loader.off(true)
        if(this.socket){
          this.u1()
        }
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

  exitLastLive() {
    this.rest.patch(`/quiz-participant/exitLive`, {session_id:(JSON.parse(localStorage.getItem('live')?? '{}'))?.liveId}).subscribe({
      next: (value) => {
        this.joinSession()
      },
      error: (value) => {
        // window.location.reload()
      },
    })
  }

  logout(){
    localStorage.clear()
    window.location.reload()
  }

  joinSession() {
    // if (JSON.parse(localStorage.getItem('live') ?? '{}')?.joinCode == this.liveId || !JSON.parse(localStorage.getItem('live') ?? '{}')?.joinCode) {
    //     this.joinSession()
    //   } else {
    //     this.showModalExitLive = true
    //   }
    this.loader.on()
    this.rest.get(`/quiz-session/${this.liveId}`).subscribe({
      next: (value: any) => {
        this.quizStatus = value.status
        localStorage.setItem('live', JSON.stringify({
          sessionToken: value.quiz_participants[0].session_token,
          joinCode: this.liveId,
          liveId: value.id,
          participantId: value.quiz_participants[0].id,
          token: localStorage.getItem('token')
        }))
        this.connectToSocket()
        this.loader.off(true)
      },
      error: (value) => {
        this.rest.post('/quiz-participant', {
          join_code: this.liveId
        }).subscribe({
          next: (value: any) => {
            localStorage.setItem('live', JSON.stringify({
              sessionToken: value.session_token,
              joinCode: this.liveId,
              liveId: value.session_id,
              participantId: value.id,
              token: localStorage.getItem('token')
            }))
            this.connectToSocket()
            this.loader.off(true)
            this.showModalExitLive = false
          },
          error: (value) => {
            this.transloco.selectTranslateObject("alerts").subscribe((alerts) => {
              this.message.showMessage(alerts[value.error.message],'error')
              if(value.error.message == 'liveAlreadyStarted' || value.error.message == 'sessionNotFound'){
                this.router.navigate(['live'])
              }
            })
            this.loader.off(true)
            
        if(value.status == 400 && value?.error?.alreadyInActiveSession){
          this.showModalExitLive = true
        }
            // this.message.showMessage('Non puoi partecipare a questa live', 'error')
          },
        })
      },
    })
  }


  getEventDetails() {
    // this.connectToSocket()
    this.loader.on()
    this.rest.get(`/quiz-session/${this.liveId}`).subscribe({
      next: (value:any) => {
        this.quizStatus = value.status
        this.loader.off(true)
        this.connectToSocket()
      },
      error: (value) => {
        this.loader.off(true)
        console.log(value);
      },
    })
  }

  toFloat(number: string) {
    return parseFloat(number)
  }

  onMapClick(event: any) {
    this.answerToQuestion = event.latLng.lat() + ',' + event.latLng.lng()

  }

  connectToSocket() {
    this.socket = io(this.urlSocket, {
      transports: ["websocket"],
      auth: JSON.parse(localStorage.getItem('live') ?? '{}')
    });

    this.listToAllEvents()
    if(this.quizStatus == 4){
      this.getRank()
      this.showRank.set(true)
    }
  }

  u1() {
    this.socket.emit('u1', 'InitUser')
  }

  listToAllEvents() {
    this.c1()
    this.c2()
    this.c3()
    this.c4()
    this.c5()
    this.c6()
    this.free()
    this.questionEnded()
    this.stopTimeQuestion()
    this.listenBuzzer()
    this.socketConnected()
    this.error()
  }

  socketConnected() {
    this.socket.on("connected", (event) => {
      this.u1()
    });
  }

  c1() {
    this.socket.on('c1', (event) => {
      this.showTimer = false
      this.showRank.set(false)
      if (event?.question_options?.length) {
        this.answers = event.question_options.map((answer: any) => {
          answer.color = this.colorById.generateColorFromId(answer.option_text + 'answer' + answer.id + this.liveId)
          return answer
        })
      }
      if(event?.question_settings?.buzzer_duration_seconds){
        this.buzzerTimeout = event?.question_settings?.buzzer_duration_seconds * 1000
      }
      this.guessNumber = ''
      this.showAnswersBuzzer = false
      this.answerToQuestion = ''
      this.currentType = event.type
      if(this.quizStatus != 4){
      this.quizStatus = 2}
      this.blockAnswers = false
    });
  }

  c2() {
    this.socket.on('c2', (event) => {
      console.log('Evento socket2:', event);
    });
  }

  c3() {
    this.socket.on('c3', (event) => {
      console.log('Evento socket3:', event);
    });
  }

  c4() {
    this.socket.on('c4', (event) => {
      console.log('Evento socket4:', event);
    });
  }

  c5() {
    this.socket.on('c5', (event) => {
      console.log('Evento socket5:', event);
    });
  }

  c6() {
    this.socket.on('c6', (event) => {
      this.yourRank = event
    });
  }

  free() {
    this.socket.on('free', (event) => {
      if (event == 'end') {
        this.quizStatus = 4
        this.quizEnded = true
        this.currentType = 0
        this.getRank()
      }
      if (event == 'showRank' && this.yourRank) {
          this.showRank.set(true)
      }
      if(event == 'start-timer'){
        this.timerStart = 5
        this.showTimer = true
        this.timeStart()
      }
    });
  }

  timeStart() {
    if (this.timerStart > 0) {
      setTimeout(() => {
        this.timerStart = this.timerStart - 1
        this.timeStart()
      }, 999);
    }
  }

  stopTimeQuestion() {
    this.socket.on('stopTimeQuestion', (event) => {
      this.isQuestionStopped = true
      this.showRank.set(false)
      this.currentType = 0
      this.getRank()
    });
  }

  questionEnded() {
    this.socket.on('question-ended', (event) => {
      this.currentType = 0
    });
  }

  listenBuzzer(){
    this.socket.on('win_buzzer', (event) => {
      this.showAnswersBuzzer = true 
      this.timeBuzzer =  this.buzzerTimeout / 1000
        this.reduceTimerBuzzer()     
      this.setTimeoutBuzzer =  setTimeout(() => {
        this.showAnswersBuzzer = false
        this.blockAnswers = true
      }, this.buzzerTimeout);
    });
  }

  reduceTimerBuzzer(){
    if(this.timeBuzzer > 0){
      setTimeout(() => {
        this.timeBuzzer = this.timeBuzzer - 1
        this.reduceTimerBuzzer()
      }, 1000);
    }
  }

  sendAnswer(answer: string) {
    this.blockAnswers = true
    if (this.setTimeoutBuzzer) {
      clearTimeout(this.setTimeoutBuzzer)
    }
    this.socket.emit('u3', answer)
  }

  sendEmoji(emoji: string) {
    this.socket.emit('u4', emoji)
    this.blockEmoji = true
    setTimeout(() => {
      this.blockEmoji = false
    }, 1000);
    this.openEmojiList()
  }

  error() {
    this.socket.on('error', (error) => {
      console.error('Errore Socket.IO:', error);
    });
  }

  changeCode(event: any,t:any) {
    if (this.newliveId.toString().length > 6) {
      this.newliveId = this.newliveId.toString().slice(0, 6)
    }
    if(event.key == 'Enter' && this.newliveId.toString().length == 6){
      this.router.navigate([`live/${this.newliveId}`])
    }
    if(event.key == 'Enter' && this.newliveId.toString().length != 6){
      this.message.showMessage(t('codeIs6'),'error')
    }
  }

  changeNumberGuess(event: any) {
    if (this.guessNumber.toString().length > 6) {
      this.guessNumber = this.newliveId.toString().slice(0, 6)
    }
  }

  activateAnimation(button: string) {
    this.animatedButton = button
    setTimeout(() => {
      this.animatedButton = ''
    }, 1000);
  }

  animationButton(index: number) {
    this.testColorIndex = index
    if (this.timeoutTestColor) {
      clearTimeout(this.timeoutTestColor)
    }
    this.timeoutTestColor = setTimeout(() => {
      this.testColorIndex = -1
    }, 500);
  }



  testColorEmit(color: string) {
    this.isDisabledColor = true
    this.socket.emit('u2', color)
    setTimeout(() => {
      this.isDisabledColor = false
    }, 2500);
  }

  openEmojiList() {
    let containerEmoji = document.getElementById('emoji-reaction')
    if (containerEmoji && !this.isEmojiOpen) {
      this.isEmojiOpen = true
      containerEmoji.classList.add('open-emoji-list')
      containerEmoji.style.height = '200px'
      containerEmoji.style.width = '50px'
      containerEmoji.style.flexWrap = 'wrap'
      setTimeout(() => {
        containerEmoji.style.overflowY = 'scroll'
        containerEmoji.classList.remove('open-emoji-list')
      }, 500);
    } else {
      if (containerEmoji && this.isEmojiOpen) {
        this.isEmojiOpen = false
        containerEmoji.style.overflowY = 'hidden'
        containerEmoji.classList.add('close-emoji-list')
        containerEmoji.style.height = '50px'
        containerEmoji.scrollTop = 0
        containerEmoji.style.width = '150px'
        containerEmoji.style.flexWrap = 'flex'
        setTimeout(() => {
          containerEmoji.classList.remove('close-emoji-list')
        }, 500);
      }
    }
  }

  changeLang(lang: string) {
    localStorage.setItem("language", JSON.stringify({ value: lang }))
    this.transloco.setActiveLang(lang)
  }

  login(t:any) {
    this.loader.on();
    this.rest
      .post(api.endpoint.login, {
        email: this.email,
        password: this.password,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.rest.setToken(value.token);
          localStorage.setItem("refreshToken", value.refresh_token);
          localStorage.setItem("user", JSON.stringify(value));
          localStorage.setItem("roleId", value.role_id);
          this.user = value.user
          this.afterAuth()
        },
        error: (value) => {
          this.loader.off(true);
          if (environment.testing) {
            this.rest.setToken("ciao");
          } else {
            this.message.showMessage(t('alerts.'+value?.error?.message), "error");
          }
        },
      });
  }

  register(t:any) {
    this.loader.on();
    this.credentials.profile_icon = this.registerEmoji
    this.rest.post(api.endpoint.register, this.credentials).subscribe({
      next: (value:any) => {
        localStorage.clear()
        
        this.loader.off(true);
        this.message.showMessage("Ti sei registrato con successo", "success");
        this.showModalRegister = false
        this.email = this.credentials.email
        this.password = this.credentials.password
        this.user = value.user
        this.login(t)
      },
      error: (value:any) => {
        this.loader.off(true);
        this.message.showMessage(t('alerts.'+value?.error?.message), "error");
      },
    });
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  checkPassword(){
    this.messagePassword =  this.helper.checkPassword(this.credentials.password)
  }

  reserveBuzzer(){
    this.socket.emit('u5')
  }

  getRank(){
    this.socket.emit('u6')
  }

  sendEmail(t:any) {
    this.showModalRecovery = false
    this.showModalLogin = true
    this.loader.on();
    this.rest
      .post(api.endpoint.sendEmailRecovery, {
        email: this.email,
      })
      .subscribe({
        next: () => {
          this.loader.off(true);
          this.message.showMessage(
           t('auth.sendedRecoveryEmail'),
            "success",
            "message-fix-index"
          );
        },
        error: (error) => {
          this.loader.off(true);
          this.message.showMessage(
            t('alerts.' + error.error.message),
            "error",
            "message-fix-index"
          );
        },
      });
  }
}
